const FormNews = {
    requiredFields: [],

    init () {
        const eventForms = document.querySelectorAll('.form-event-container');

        if (window.NodeList && !NodeList.prototype.forEach) {
            NodeList.prototype.forEach = Array.prototype.forEach;
        }

        [].forEach.call(eventForms, (eventForm) => {
            this.checkInvisibleRequired(eventForm);
            this.setHiddenValues();
            this.initFormEventPcv();
        });
    },

    checkInvisibleRequired (eventForm) {
        const groups = eventForm.querySelectorAll('.group');
        const inputs = eventForm.querySelectorAll('input[aria-required="true"]');
        [].forEach.call(inputs, input => {
            this.requiredFields.push(input.getAttribute('name'));
        });

        [].forEach.call(groups, group => {
            const groupName = group.classList[0];
            const name = groupName.split('-')[1];

            const radios = eventForm.querySelectorAll('input[name="'+name+'"][type="radio"]');
            [].forEach.call(radios, radio => {
                const radioInitVal = radio.value;
                if (radio.checked && radio.value === 'Oui') {
                    this.updateVisibility(eventForm, groupName, radioInitVal);
                } else if (radio.checked && radio.value === 'Non') {
                    this.updateVisibility(eventForm, groupName, radioInitVal);
                }
                radio.addEventListener('click', () => {
                    const radioVal = radio.value;
                    this.updateVisibility(eventForm, groupName, radioVal);
                });
            });
        });
    },

    updateVisibility (eventForm, groupName, val) {
        if (val == 'Oui') {
            eventForm.querySelector('.' + groupName).classList.remove('closed');
        } else {
            console.log('updateVisibility: ', groupName);
            eventForm.querySelector('.' + groupName).classList.add('closed');
            if (groupName.indexOf('invitation') != -1) {
                const start = parseInt(groupName.split('invitation_')[1], 10) + 1;
                const next = eventForm.querySelector('.group-invitation_' + start);
                if (next) {
                    eventForm.querySelector('.last input[name="invitation_' + start + '"]').checked = true;
                    this.updateVisibility(eventForm, 'group-invitation_' + start, 'Non');
                }
            }
        }
        this.setRequired(eventForm, groupName, val);
    },

    setRequired (eventForm, groupName, val) {
        const inputs = eventForm.querySelectorAll('.' + groupName + ' input');
        [].forEach.call(inputs, input => {
            if (this.requiredFields.indexOf(input.getAttribute('name')) !== -1) {
                if (val === 'Oui') {
                    if (input.value == 'NA' || input.value == 'NA@NA.NA') {
                        input.value = '';
                        input.classList.remove('has-content');
                    }
                } else {
                    this.setDefaultInputValue(input);
                }
            }
        })
    },

    setHiddenValues () {
        document.querySelector('.form-event-container .actu-title').value = document.querySelector('h1').innerHTML;
        document.querySelector('.form-event-container .actu-url').value = window.location.href;
    },

    initFormEventPcv () {
        const eventFormsPcv = document.querySelectorAll('.form-event-container.form-event-container-pcv');
        const selectOptions = {
            "Une opération ponctuelle ou saisonnière": "group-operation_ponctuelle", 
            "Une collectivité locale": "group-collectivite_locale", 
            "Banque": "group-nom_banque", 
            "Autres": "group-precisez"
        };

        const $select = document.querySelector('.etes-vous');
        console.log('click', $select);
        $select.addEventListener('click', (event) => {
            console.log('event: ', event);
        });
        console.log('initformeventpcv');
        [].forEach.call(eventFormsPcv, eventFormPcv => {
            console.log('eventForm:', eventFormPcv);
            const $select = eventFormPcv.querySelector('select.etes-vous');
            $select.addEventListener('change', event => {
                console.log('input target: ', event.target.classList);
                if (event.target.classList.contains('etes-vous')) {
                    console.log('input etes vous: ', event.target.value);
                    eventFormPcv.querySelectorAll('.group-etes-vous').forEach(fieldsGroup => {
                        fieldsGroup.classList.add('closed');
                        fieldsGroup.querySelectorAll('input').forEach(input => {
                            this.setDefaultInputValue(input);
                        });
                    });
                    if (selectOptions[event.target.value]) {
                        eventFormPcv.querySelector('.' + selectOptions[event.target.value]).classList.remove('closed');
                        eventFormPcv.querySelectorAll('.' + selectOptions[event.target.value] + ' input').forEach(input => {
                            input.value = '';
                        });
                    }
                }
            });
            

            //
            // 
            if (selectOptions[eventFormPcv.querySelector('.etes-vous').value]) {
                eventFormPcv.querySelector('.' + selectOptions[eventFormPcv.querySelector('.etes-vous').value]).classList.remove('closed');
                console.log('select:', selectOptions[eventFormPcv.querySelector('.etes-vous').value], eventFormPcv.querySelector('.' + selectOptions[eventFormPcv.querySelector('.etes-vous').value]).classList, eventFormPcv.querySelector('.' + selectOptions[eventFormPcv.querySelector('.etes-vous').value]));
            }

            setTimeout(() => {
                eventFormPcv.querySelectorAll('.group-etes-vous').forEach(group => {
                    if (group.classList.contains('closed')) {
                        console.log('group:', group);
                        group.querySelectorAll('input').forEach(input => {
                            console.log('input:', input);
                            this.setDefaultInputValue(input);
                        });
                    }
                });
            }, 500)

            
        });
    },

    setDefaultInputValue (input) {
        if (input.getAttribute('type') == 'email') {
            input.value = 'NA@NA.NA';
        } else {
            input.value = 'NA';
        }
    }
}

export default FormNews;